<template>
  <div>
    <div class="row">
      <el-select v-model="currentCompany" style="width:400px;" clearable>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <!-- <el-button
        type="primary"
        icon="el-icon-search"
        round
        style="margin-left:50px;"
        @click="search()"
      >{{$t("button.search")}}</el-button> -->
      <cus-btn type="search" style="margin-left:50px;" @click="search()"></cus-btn>
    </div>
    <el-row class="row" :gutter="10">
      <el-col :span="24">
        <overdue-list :autoLoad="false" ref="overdueList" @more="overdueMore" />
      </el-col>
    </el-row>
    <el-row class="row" :gutter="10">
      <el-col :span="24">
        <project-status :autoLoad="false" ref="projectStatus"  @more="projectStatusMore" />
      </el-col>
    </el-row>
    <el-row class="row" :gutter="10">
      <el-col :span="24">
        <patent-top-10 :autoLoad="false" ref="patentTop10" @more="topTenMore" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import overdueList from './components/overdueList'
import patentTop10 from './components/patentTop10'
import projectStatus from './components/projectStatus'

//import { MyCompanyList } from '@/api/enumInfo'

import { getCompany } from '@/api/homes'

export default {
  components: {
    'overdue-list': overdueList,
    'patent-top-10': patentTop10,
    'project-status': projectStatus
  },
  mixins: [],
  props: {},
  data() {
    return {
      htmlTitle: 'test',

      options: [],
      currentCompany: null
    };
  },
  computed: {},
  watch: {},
  created() {
    getCompany().then(resp => {
      const data = resp.data
      for (let i = 0; i < data.length; i++) {
        this.options.push({
          value: data[i].id,
          label: data[i].companyName
        });
      }
      this.search();
    })

  },
  mounted() {},
  destroyed() {},
  methods: {
    search() {
      if(this.currentCompany === ""){
        this.currentCompany = null
      }
      
      this.$refs.overdueList.loadData(this.currentCompany);
      this.$refs.projectStatus.loadData(this.currentCompany);
      this.$refs.patentTop10.loadData(this.currentCompany);
    },

    overdueMore(){
      if(this.currentCompany === null){
        this.$router.push({ path: '/projectManagement/projectListView', query: { overdue: '1',isAvaliable:0 }})
      }else{
        const selectedItem = this.options.filter(item=>{return item.value == this.currentCompany})
        if(selectedItem.length > 0){
          this.$router.push({ path: '/projectManagement/projectListView', query: { overdue: '1',isAvaliable:0,companyId:this.currentCompany,companyName:selectedItem[0].label }})
        }
      }
    },
    projectStatusMore(){
      if(this.currentCompany === null){
        this.$router.push({path:'/projectManagement/projectListView'})
      }else{
        const selectedItem = this.options.filter(item=>{return item.value == this.currentCompany})
        if(selectedItem.length > 0){
          this.$router.push({ path: '/projectManagement/projectListView', query: { companyId:this.currentCompany,companyName:selectedItem[0].label }})
        }
      }
    },
    topTenMore(){
      if(this.currentCompany === null){
      this.$router.push({ path: "/patentManagement/patentListView", query: {mainType: 1}});
      }else{
        const selectedItem = this.options.filter(item=>{return item.value == this.currentCompany})
        if(selectedItem.length > 0){
          this.$router.push({ path: '/patentManagement/patentListView', query: { companyId:this.currentCompany, companyName:selectedItem[0].label, mainType: 1 }})
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.row {
  margin-bottom: 10px;
}
</style>
